import { useState, useEffect, useCallback } from 'react';
import { createApiUrl } from '../utils/apiConfig';
import { getAuthHeaders } from '../utils/authUtils';

/**
 * Loads My Tasks / Team Tasks counts (same filtering as Dashboard) for AppBar badges.
 */
export function useReportingTaskCounts(currentUser, enabled) {
  const [myTasks, setMyTasks] = useState(0);
  const [teamTasks, setTeamTasks] = useState(0);

  const refresh = useCallback(async () => {
    if (!enabled || !currentUser?.id) {
      setMyTasks(0);
      setTeamTasks(0);
      return;
    }
    try {
      const [myTasksResponse, teamTasksResponse] = await Promise.all([
        fetch(createApiUrl(`my-first-reader-reports/${currentUser.id}`), {
          headers: getAuthHeaders(),
        }),
        fetch(createApiUrl('all-pending-reports'), { headers: getAuthHeaders() }),
      ]);

      const myTasksData = myTasksResponse.ok ? await myTasksResponse.json() : [];
      const teamTasksData = teamTasksResponse.ok ? await teamTasksResponse.json() : [];

      const myTasksFiltered = myTasksData.filter((exam) => {
        const reportStatus = exam.report_status;
        return (
          reportStatus !== 'APPROVED' &&
          reportStatus !== 'Approved' &&
          reportStatus !== 'approved'
        );
      });

      const teamTasksFiltered = teamTasksData.filter((exam) => {
        const reportStatus = exam.report_status;
        return (
          reportStatus !== 'APPROVED' &&
          reportStatus !== 'Approved' &&
          reportStatus !== 'approved'
        );
      });

      setMyTasks(myTasksFiltered.length);
      setTeamTasks(teamTasksFiltered.length);
    } catch (e) {
      console.warn('useReportingTaskCounts:', e);
    }
  }, [currentUser?.id, enabled]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    if (!enabled) return undefined;
    const id = setInterval(refresh, 60000);
    return () => clearInterval(id);
  }, [enabled, refresh]);

  return { myTasks, teamTasks, refresh };
}
